/**
 *
 */
export enum PropertyAdvertSortOptionID {
  NewestFirst = 1,
  PriceAscending = 2,
  PriceDescending = 4,
  Surface = 5,
}
